module.exports = __webpack_public_path__ + "img/JA.e1a47c10.svg";